import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import ModalPortal from '../../../../../components/modal-portal';
import { V2IframeService } from '../../../../../services/v2-iframe-service';
import { getReferenceData } from '../../../../../store/reference-data/reference-data.actions';
import { listenToMessages } from '../../../../../services/iframe-message-listener-service';
import style from './marketplace-setup.module.less';

const V2MarketplaceSettingsModal = ({ storeGuid, onClose, onSave }) => {
  const [subscriptionToMessage, setSubscriptionToMessage] = useState();
  const dispatch = useDispatch();
  const url = `${V2IframeService.getv2iFrameUrl()}/#/marketplaces/settings/${storeGuid}?v3iframe=true`;

  useEffect(() => {
    const cleanup = () => {
      if (!subscriptionToMessage) {
        return;
      }
      subscriptionToMessage();
      setSubscriptionToMessage(undefined);
    };
    if (subscriptionToMessage) {
      return cleanup;
    }
    const newListener = (message) => {
      if (message.eventType === 'v2MarketplaceModalClosed') {
        onClose();
        return;
      }
      if (message.eventType === 'v2MarketplaceModified') {
        dispatch(getReferenceData());
        onSave();
      }
    };
    setSubscriptionToMessage(listenToMessages(newListener));
    return cleanup;
  }, [subscriptionToMessage, setSubscriptionToMessage, dispatch, onClose, onSave]);

  return (
    <ModalPortal containerId='marketplace-v2-settings-modal' onClose={onClose}>
      <Modal className={style['marketplace-settings-modal']} size='custom'>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage defaultMessage='Edit an existing marketplace' description='v2 marketplace settings modal header' id='LgX+Z1' />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <iframe className={style.iframe} src={url} title='v2 marketplace iframe' />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

V2MarketplaceSettingsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  storeGuid: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default V2MarketplaceSettingsModal;
